import { useGetAuthSessionQuery } from '@/api/serverApi'
import { Navbar, SettingsNavigation } from '@/components/header'
import TeamMemberList from '@/components/tables/TeamMemberList'
import { LoadingSpinner, Meta } from '@cfs-fixings/shared'

const TeamMembersPage = () => {
  const textSpec = {
    title: 'Team Members',
    subtitle: 'Manage and invite your team members here',
  }

  const { data, isLoading } = useGetAuthSessionQuery()

  return <>
    <Meta title="Team Members" />

    <Navbar topbar={<div></div>} content={<SettingsNavigation />}>
      <div className="flex justify-center w-full">
        <div className="flex flex-col items-center gap-[30px] w-full max-w-[615px]">
          <div className="flex flex-col items-start w-full max-w-[615px]">
            <h1 className="text-2xl leading-[28.8px] font-semibold">{textSpec.title}</h1>
            <h2 className="text-sm leading-[19.6px] font-medium">{textSpec.subtitle}</h2>
          </div>

          <div className="border-t border-grey-100 w-full max-w-[615px]"></div>

          {
            data?.data && !isLoading
              && <TeamMemberList customer={data!.data!.customer} />
          }

          {
            !data?.data && isLoading
              && <div className="w-full flex items-center justify-center">
                <LoadingSpinner className="h-4 w-4" />
              </div>
          }
        </div>
      </div>
    </Navbar>
  </>
}

export default TeamMembersPage
